const user = {
  changePass: 'Change Password',
  editProfile: 'Edit Profile',
  emailVerifiedSuccess: 'Email successfully verified.',
  emailCantVerified: 'Your email could not be verified.',
  changeLang: 'Change Language',
  english: 'English',
  vietnamese: 'Vietnamese',
  chineseSimplified: 'Chinese (Simplified)',
  spanish: 'Spanish',
  chineseTraditional: 'Chinese (Traditional)',
  malay: 'Malay',
}

export type LocaleUser = typeof user

export default user
